import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BreakpointKeys, Breakpoints } from '../breakpoints';
@UntilDestroy()
@Component({
  selector: 'srcset-image',
  templateUrl: './srcset-image.component.html',
  styleUrls: ['./srcset-image.style.scss'],
})
export class SrcsetImageComponent extends BaseComponent implements OnInit {
  @Input() imageClass: string = 'scrset-image';
  @Input() srcsets: BreakpointKeys[] = ['sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'];
  @Input() src!: string;
  @Input() alt: string = '';
  @Input() title: string = '';

  @Output() onLoad: EventEmitter<boolean> = new EventEmitter();

  public srcsetString!: string;
  public sizesString!: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initSrcsetStrings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes['src'] || changes['srcsets'])) {
      this.initSrcsetStrings();
    }
  }

  initSrcsetStrings() {
    if (!this.src || this.srcsets.length == 0) {
      return;
    }

    this.srcsetString = '';
    this.sizesString = '';

    this.srcsets.forEach((set: BreakpointKeys) => {
      //srcset
      if (this.srcsetString != '') {
        this.srcsetString += ', ';
      }
      this.srcsetString +=
        this.src +
        (this.src.charAt(this.src.length - 1) == '/' ? '' : '/') +
        Breakpoints[set] +
        ' ' +
        Breakpoints[set] +
        'w';

      //sizes
      // if (this.sizesString != '') {
      //   this.sizesString += ', ';
      // }
      // this.sizesString +=
      //   '(max-width: ' + Breakpoints[set] + 'px) ' + Breakpoints[set] + 'px';
      this.sizesString =
        '(max-width: ' +
        Breakpoints.xxxl +
        'px) 100vw, ' +
        Breakpoints.xxxl +
        'px';
    });
  }
}
